import React from 'react';
import { Stats } from '../types';
import './StatsCard.css';

interface StatsCardProps {
  stats: Stats;
  scoresReleased?: boolean;
}

const StatsCard: React.FC<StatsCardProps> = ({ stats, scoresReleased = true }) => {
  return (
    <div className="stats-card">
      <h2>Your Progress</h2>
      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-value">{stats.completedItems}</div>
          <div className="stat-label">Items Completed</div>
        </div>
        <div className="stat-item">
          <div className="stat-value">{stats.totalItems}</div>
          <div className="stat-label">Total Items</div>
        </div>
        <div className="stat-item">
          <div className="stat-value">{scoresReleased ? stats.totalScore : 'To be released'}</div>
          <div className="stat-label">Points Earned</div>
        </div>
        <div className="stat-item">
          <div className="stat-value">{stats.completionPercentage}%</div>
          <div className="stat-label">Complete</div>
        </div>
      </div>
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${stats.completionPercentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default StatsCard;
